<template lang="pug">
AppCard(padding="lg" elevated)
  .payment-status
    span.payment-status__badge(:class="variant")
      i(:class="currentIcon")
    h2 {{ title }}
    p {{ subtitle  }}
    div
      slot
    router-link(:to="{ name: 'Login' }" v-slot="{ navigate }" custom)
      AppButton(:label="labelValue" @click="navigate")
</template>

<script>
import AppCard from "@/components/AppCard";
import AppButton from "@/components/AppButton";
import { computed } from "@vue/runtime-core";
import { useI18n } from "vue-i18n";

export default {
  components: { AppCard, AppButton },
  props: {
    title: String,
    subtitle: String,
    icon: {
      type: String,
      default: "check-circle",
    },
    variant: {
      type: String,
      default: "success",
      validator: (value) => ["success", "danger"].indexOf(value) !== -1,
    },
    label: {
      type: String,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const labelValue = computed(() =>
      props.label ? props.label : t("payment.success_button")
    );
    const currentIcon = computed(() => {
      return `uil uil-${props.icon}`;
    });
    return { currentIcon, labelValue };
  },
};
</script>

<style lang="scss" scoped>
.payment-status {
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply justify-center;

  &__badge {
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply h-20;
    @apply w-20;
    @apply mb-4;
    @apply rounded-full;
    @apply bg-gignetgreen-200;

    i {
      @apply text-5xl;
      @apply leading-none;
      @apply text-gignetgreen-600;
    }

    &.danger {
      @apply bg-red-100;
      i {
        @apply text-red-500;
      }
    }
  }

  h2 {
    @apply text-lg;
    @apply text-bluegray-700;
    @apply font-semibold;
    @apply mb-2;
    @apply text-center;
  }
  p {
    @apply text-bluegray-400;
    @apply text-sm;
    @apply leading-snug;
    @apply text-center;
    @apply mb-8;
  }
}
</style>
